import "./styles.css";
import React, { useEffect, useState } from "react";
import WishlistItem from "./components/WishlistItem";
import { connect } from "react-redux";
import { getWishlist } from "../../../../redux/actions/wishlist";
import { Loader, Divider } from "semantic-ui-react";
import { Link } from "react-router-dom";
const Wishlist = ({ wishlist, getWishlist, auth }) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (auth.isLoaded) {
      getWishlist();
    }
  }, [auth.isLoaded, getWishlist]);
  useEffect(() => {
    if (auth.isLoaded && !wishlist.loading) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [auth.isLoaded, wishlist.loading]);

  return (
    <div className="p-5 pt-0" style={styles.container}>
      <div>
        {loading ? (
          <div className="account-loader-container">
            <Loader active inline="centered" />
          </div>
        ) : wishlist.data.length === 0 ? (
          <h3 className="mb-20">Tu wishlist está vacía</h3>
        ) : (
          <div>
            <h3 className="mb-20">Arreglos agregados a su Wishlist</h3>
            {wishlist.data.map((item, index) => (
              <div key={index}>
                <WishlistItem key={index} productDetails={item} />
                {index !== wishlist.data.length - 1 && <Divider />}
              </div>
            ))}
          </div>
        )}
      </div>
      {!loading && (
        <div className="wishlist-container-button">
          <Link
            className="btn btn-dark rounded font-weight-400 mt-20"
            to="/products/Todos"
          >
            Agrega items a tu wishlist
          </Link>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#f0f0f0",
  },
  logo: {
    width: 150,
    height: 100,
  },
};
const mapStateToProps = ({ wishlist, firebase: { auth } }) => {
  return { wishlist, auth };
};
export default connect(mapStateToProps, { getWishlist })(Wishlist);
